var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"download-button"},[_c('i',{staticClass:"fa fa-download download-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }